import React from 'react'
import { t } from 'i18next'

import { SpendLineChart } from '~/modules/retailMedia/components/BudgetConsumptionReport'
import useInView from '~/modules/retailMedia/hooks/useInView'
import { useTotalSpend, isNoSpendDataError } from '~/modules/retailMedia/hooks/useSpendReports'

import ChartBox from '../ChartBox'
import * as S from '../../styles'

type DateRange = { start_date: string; end_date: string }

export interface TotalSpendSectionProps {
  campaignId: string
  dateRange: DateRange
  overviewReady: boolean
  campaignEndAt?: string
}

const TotalSpendSection = ({ campaignId, dateRange, overviewReady, campaignEndAt }: TotalSpendSectionProps) => {
  const [ref, isInView] = useInView()
  const { data, isPending, isFetching, error, refetch } = useTotalSpend(campaignId, dateRange, isInView && overviewReady, campaignEndAt)

  return (
    <S.Section ref={ref}>
      <S.SectionTitle>{t('rm:spendReport.section.totalSpend')}</S.SectionTitle>
      <ChartBox
        loading={!isInView || (isPending && !data && !error)}
        refreshing={isInView && isFetching && (!!data || !!error)}
      >
        {(data || error) && (
          <SpendLineChart
            {...(data ?? {})}
            endLabel={campaignEndAt ? t('rm:spendReport.chart.endLine') : undefined}
            error={!!error}
            errorMessage={isNoSpendDataError(error) ? t('rm:spendReport.error.noSpendData') : undefined}
            onRetry={isNoSpendDataError(error) ? undefined : refetch}
          />
        )}
      </ChartBox>
    </S.Section>
  )
}

export default TotalSpendSection
